module.exports = __webpack_public_path__ + "static/media/badge.699e951b.png";